<script>
    import { onMount } from 'svelte'
    import { navigate  } from 'svelte-routing'

    let CountTimer
	onMount(async () => {
        CountTimer = 3
        let intervalId = setInterval(() => {
            CountTimer--
            
            if(CountTimer <= 0) {
                clearInterval(intervalId)
                navigate("/", { replace: true })
            }
        }, 1000);
    })
</script>

<div class="not">
    <h2>Page Not Found</h2>
    <p>
        Sorry, the page you're looking for doesn't exist.
        Waiting for {CountTimer} second...
    </p>
    <p>
        죄송합니다, 해당 페이지는 없는 페이지입니다.
        {CountTimer} 초 후 이동합니다...
    </p>
</div>

<style lang="scss">
    .not {
        padding: 20px;

        h2 {
            margin: 0px;
            color: $cl4;
            font-size: 30px;
            font-family: aggro;
        }

        p {
            color: $cl2;
            font-size: 16px;
        }
    }
</style>